import { Component, inject, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { CareerPageService } from '../../../../services/career-page.service';
import { Career } from '../../../../models/career';

@Component({
  selector: 'app-careerss-to-explore',
  imports: [RouterLink, MatCardModule, MatListModule, MatDividerModule, MatButtonModule],
  templateUrl: './careerss-to-explore.html',
  styleUrl: './careerss-to-explore.css',
})
export class CareerssToExplore {
  careerService = inject(CareerPageService);
  router = inject(Router);
  careers = signal<Career[]>([]);

  ngOnInit() {
    this.getCareers();
  }

  getCareers() {
    this.careerService.getCareers().subscribe((careers) => {
      this.careers.set(careers.slice(0, 4));
    });
  }

  openPage(c: Career) {
    this.router.navigate(['/counselors/careers', c.id]);
  }
}
